/* Samedi card Add to cart, 22 Sep 2026 round 45 (LIGHT test theme).
   This was inline in sections/samedi-collection.liquid and bound to that one grid, so the same
   card rendered on search, on 404 and in the cart recommendations had a width picker that could
   never open and a submit with no variant id: the post failed and the button just said
   "Unavailable". The behaviour now lives here, delegated on document, so every place that renders
   snippets/samedi-lcard.liquid behaves the same.
   The form is a .bcard-add-form, so samedi.js posts it and opens the bag drawer exactly as the
   product page does. This only adds the width step: on a product with more than one width the
   first tap opens the width choice over the photo instead of submitting, and choosing a width
   submits. Nothing is ever added without a chosen width. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-lt-pick]:not([hidden])').forEach(function (pk) {
      if (pk === except) return;
      pk.hidden = true;
      var b = pk.parentNode.querySelector('[data-lt-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function choose(input) {
    var form = input.form,
      pick = input.closest('[data-lt-pick]'),
      btn = form.querySelector('[data-lt-open]');
    if (pick) pick.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (form.requestSubmit) form.requestSubmit();
    else if (btn) btn.click();
    /* clear the choice once the add has been sent and reported, so the next tap asks again */
    setTimeout(function () { input.checked = false; }, 2500);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lt-open]');
    if (open) {
      var form = open.form, pick = form && form.querySelector('[data-lt-pick]');
      if (pick && !form.querySelector('[name=id]:checked')) {
        e.preventDefault();
        closeAll(pick);
        pick.hidden = false;
        open.setAttribute('aria-expanded', 'true');
        var first = pick.querySelector('input:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }

    var x = e.target.closest('[data-lt-close]');
    if (x) {
      var pk = x.closest('[data-lt-pick]');
      if (pk) {
        pk.hidden = true;
        var b = pk.parentNode.querySelector('[data-lt-open]');
        if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      }
      return;
    }

    var lab = e.target.closest('.lt-opt');
    if (lab && !lab.classList.contains('is-sold')) {
      var input = lab.querySelector('input');
      if (input) {
        if (e.target !== input) { e.preventDefault(); input.checked = true; }
        choose(input);
      }
      return;
    }

    if (!e.target.closest('.lt--atc')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    var pick = e.target.closest && e.target.closest('[data-lt-pick]');
    if (!pick) return;
    if (e.key === 'Escape') {
      var b = pick.parentNode.querySelector('[data-lt-open]');
      pick.hidden = true;
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('input[type=radio]:not([disabled])')) {
      e.preventDefault();
      e.target.checked = true;
      choose(e.target);
    }
  });
})();
